module.exports = __webpack_public_path__ + "static/media/skiman.81aa76a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/registeration/skiman.svg
// module id = 720
// module chunks = 0